import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
  @Input() loading;
  @Input() loaderContainerHeight: number = 350;

  constructor() { }

}


@Component({
    selector: 'app-wizard-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss']
  })
  export class WizardLoaderComponent {
    @Input() loading;
    @Input() loaderContainerHeight: number = 350;

    constructor() { }

  }
